<!--月度业绩目标设置-->
<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            :showSaveBtn="false"
            :disabled="!isEdit"
            ref="form"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="业绩预测分录">
        <div slot="content">
          <edit-data-table
            ref="entries"
            :head="editTable.tableHead"
            :data.sync="tableData"
            :edit-rules="entryRules"
            :config="{ trigger: 'click', mode: 'row', autoClearActive: false }"
            :editable="isEdit"
            :showAdd="isEdit"
            height=""
          >
            <template #projectTypeId="{ row }">
              <span>{{ row.projectTypeId ? row.projectTypeId.code : "" }}</span>
            </template>
            <template #projectTypeIdEdit="{ row }">
              <data-box
                hostUrl="/projectDelivery"
                :props="{ label: 'code', value: 'id' }"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectTypeId"
                :extendParms="{ billState: 3, searchType: 4 }"
                @confirm="(val) => projectDetail(row, val)"
              ></data-box>
            </template>

            <template #milestoneNode="{ row }">
              <span v-if="row.projectTypeId">{{ row.milestoneNode ? row.milestoneNode.milestoneName : "" }}</span>
              <span v-else>先选择项目</span>
            </template>
            <template #milestoneNodeEdit="{ row }">
              <data-box
                v-if="row.projectTypeId"
                hostUrl="/milestoneplan"
                :props="{ label: 'milestoneName', value: 'id' }"
                :tableColumn="milestoneNodeHead"
                :multiple="false"
                v-model="row.milestoneNode"
                :extendParms="{ parentId: row.projectTypeId.id }"
                @confirm="(val) => planDetail(row, val)"
              ></data-box>
              <span v-else>先选择项目</span>
            </template>

            <template #toolbar="scope">
              <div v-if="!isEdit">无</div>
              <el-popover
                :ref="scope.$index + 'a'"
                placement="top"
                width="180"
                v-if="isEdit"
              >
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[scope.$index + 'a'].doClose()"
                    >取消</el-button
                  >
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="delEntry(scope.row.id, scope)"
                    >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  slot="reference"
                ></el-button>
              </el-popover>
            </template>
            <template #num="{ row }">
              <div>{{ row.num ? row.num : (row.num = 1) }}</div>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button
          class="btn-cancel"
          v-if="isEdit"
          :loading="loading"
          @click="save(0)"
          >保存</el-button
        >
       <!-- <el-button
          class="btn-submit"
          v-if="isEdit"
          :loading="loading"
          @click="submit(1)"
          >提交</el-button
        > -->
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import { parseTime } from "@/utils";
import DataTableMixin from "@/mixins/DataTableMixin";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { saveMonthKpi, getMonthKpi } from "@/api/bill/monthkpi";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";
import CrudMixin from "@/mixins/CrudMixin";

export default {
  name: "MonthKpiForm",
  mixins: [DataTableMixin, initDict, CrudMixin],
  components: {
    FoldedPanel,
    DataBox,
  },
  data() {
    return {
      id: "",
      form: { },
      isEdit: false,
      delLoading: false,
      tableDatas: [],
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "projectName", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      milestoneNodeHead: [
        {
          label: "项目阶段",
          prop: "milestoneName",
          editRender: { type: "default" }
        }
      ],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "monthly",
            label: "业绩月度",
            value: "",
            placeholder: "2021-01",
            span: 24,
            disabled: false,
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 24,
            maxlength: 200,
          },
        ],
      },
      editTable: {
        showNumber: true,
        enableEdit: true,
        showAdd: true,
        tableHead: [
          {
            label: "立项编码",
            prop: "projectTypeId",
            editRender: {
              type: "default"
            }
          },
          {
            label: "项目号",
            prop: "projectCode",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          },
          {
            label: "项目名称",
            prop: "projectName",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          },
          {
            label: "项目阶段",
            prop: "milestoneNode",
            editRender: {
              type: "default"
            }
          },
          {
            label: "预计业绩收入",
            prop: "confirmMoney",
            width: '140px',
            editRender: { type: "default", name: "ElInput", }
          },
        ],
      },
      tableData: [],
      loading: false,
      validateRefNames: ["form","entries"],
      entryRules: {
        projectTypeId: [{ required: true, message: "不能为空", trigger: "blur" }],
        confirmMoney: [{ required: true, message: "不能为空", trigger: "blur" ,type: 'number'},
        {
            validator(rule, value, callback) {
              const reg = /^\d+\.?(\d{1,2})?$/
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("小数点后保留两位"));
              }
            },
            trigger: "change"
          }]
      }
    };
  },
  watch: {

  },
  created() {
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      // 存在id则按id获取表单信息
      // TODO
      getMonthKpi(this.id).then((res) => {
        // 详情
        const data = res.data;
        this.form.monthly = data.monthKpi.monthly
        this.form.remark = data.monthKpi.remark
        const table = [];
        data.entries.forEach((item) => {
          const tableRow = {};
          tableRow.deliveryId = item.projectId;
          tableRow.projectCode = item.projectNumber;
          tableRow.projectName = item.projectName;
          tableRow.confirmMoney = item.confirmMoney
          const milestoneNodeObject = {};
          milestoneNodeObject.id = item.milestonePlanId;
          milestoneNodeObject.milestoneName = item.milestonePlanName
          tableRow.milestoneNode = milestoneNodeObject;
           const projectTypeId = {};
           projectTypeId.id = item.projectId;
           projectTypeId.code = item.deliveryCode;
           tableRow.projectTypeId = projectTypeId;
           table.push(tableRow);
        })
        this.tableData = table;
      });
    } else {
      // 填写月度
      this.form.monthly = this.getMonthly()
    }
  },
  methods: {
    delEntry(id, scope) {
       this.tableData.splice(scope.$index, 1)
    },
    getMonthly() {
      return parseTime(new Date(),'{y}-{m}')
    },
    projectDetail (row, val) {
      row.projectTypeId = val;
      row.deliveryCode = val.code;
      row.projectCode = val.bsProject.code;
      row.projectName = val.bsProject.name;
      row.deliveryId = val.id;
      row.contractId = this.id;
      row.milestoneNode = undefined
    },
    planDetail(row, val) {
      row.milestoneNode = val;
    },
    submitConfirm(val) {
      const obj = this.getFormData(2);
      const obj2 = {};
      val.forEach((item) => {
        let userList = "";
        item.assignData.forEach((ite) => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2);
      obj.from = "moai";
      // console.log('rjuq..',obj)
      this.pull(obj);
    },
    // 提交
    submit(status) {
      this.loading = true;
      this._validateForm(this.validateRefNames)
        .then((res) => {
          // this.pull(this.getFormData(status));

        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 保存
    save(status) {
            this.loading = true;
      // this.getFormData(status)
      this.pull(this.getFormData(status));
    },
    // 组装数据
    getFormData(status) {
      const paramsBody = {}
      const monthKpi = {} // 单据数据
      monthKpi.monthly = this.form.monthly
      monthKpi.remark = this.form.remark
      monthKpi.code = getDocumentCode("YDYJ")
      monthKpi.status = status
      if (this.id && this.id != null) {
        monthKpi.id = this.id
      }
      paramsBody.monthKpi = monthKpi
      const entries = []
      this.tableData.forEach((item) => {
        const entriesObj = {}
        entriesObj.projectId = item.deliveryId
        entriesObj.milestonePlanId = item.milestoneNode.id
        entriesObj.confirmMoney = item.confirmMoney
        entries.push(entriesObj)
      })
      paramsBody.entries = entries
      return paramsBody
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    back() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    pull(obj) {
        saveMonthKpi(obj).then((res) => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500,
            });
            this.loading = false;
          }
        });
      this.cancel();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
  padding-top: 20px;
  text-align: right;

  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }

  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
